module.exports = __webpack_public_path__ + "s5.no2.1be6b417.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/s5.no2.jpg
// module id = 3EBq
// module chunks = 0